module.exports = __webpack_public_path__ + "img/japan-lung-cancer-female.54aa2b99.png";